import { render, staticRenderFns } from "./CouponsPerUnitTable.vue?vue&type=template&id=645947e0&scoped=true"
import script from "./CouponsPerUnitTable.vue?vue&type=script&lang=js"
export * from "./CouponsPerUnitTable.vue?vue&type=script&lang=js"
import style0 from "./CouponsPerUnitTable.vue?vue&type=style&index=0&id=645947e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645947e0",
  null
  
)

export default component.exports